<template>
  <v-scale-transition>
    <kits-panel :kits-items="subscriberGroup">
      <h3 class="headline grey--text text-xs-center hidden-sm-and-down">
        KPI Menu
      </h3>
    </kits-panel>
  </v-scale-transition>
</template>

<script>
export default {
  components: {
    KitsPanel: () => import(/* webpackChunkName: "kitsPanel" */ '@/components/KitsPanel'),
  },
  data () {
    return {
    }
  },
  computed: {
    subscriberGroup: function () {
      const menu = [
        {
          icon: 'mdi-note-text-outline',
          path: '/kpi',
          title: 'KPI',
          desc: 'Dealer KPI',
        },
        {
          icon: 'mdi-target',
          path: '/target_kpi',
          title: 'Target KPI',
          desc: 'Annual Payout & Black AI',
        },
      ]

      return menu
    },
  },
}
</script>
